module.exports = function(app) {

	var songFormOptions = require('./song-form-options')();
	var ageRangeOptions = songFormOptions.ageRanges;

	//Define reactive functions
	app.on('model', function(model) {
		//used by the song list page only; calls composerAndLyricistNames() and also sorts the age ranges
		model.fn('prepareSongResults', function(songs) {
			var result = composerAndLyricistNames(songs);
			result.forEach(function(song) {
				//TODO
				//Figure out why age ranges aren't being saved in order in the first place
				//Sort age ranges
				sortAgeRanges(song);
			});

			return result;
		});

		//used by show list and song list pages
		model.fn('composerAndLyricistNames', composerAndLyricistNames);
		function composerAndLyricistNames(showsOrSongs) {
			var i = 0;
            var result = [];
            showsOrSongs.forEach(function(showOrSong) {
                showOrSong.composerNames = getComposerOrLyricistNames(showOrSong, 'composers');
                showOrSong.lyricistNames = getComposerOrLyricistNames(showOrSong, 'lyricists');
                result.push(showOrSong);
            });

            return result;
        }

		//for use with a single song or show
		model.fn('composerAndLyricistNamesSingle', function(showOrSong) {
			if (!showOrSong) return showOrSong;
			showOrSong.composerNames = getComposerOrLyricistNames(showOrSong, 'composers');
			showOrSong.lyricistNames = getComposerOrLyricistNames(showOrSong, 'lyricists');

			//hopefully we won't need the sortAgeRanges function in the future if we can ensure that
			//they'll always be in the right order in the DB
			//but in the meantime we'll just stick this here even though the function should be renamed if it were to stay here...
			if (showOrSong.ageRanges) sortAgeRanges(showOrSong);

			return showOrSong;
		});
	});

	function getComposerOrLyricistNames(showOrSong, composersOrLyricists) {
		//note: isCompilation is only applicable for shows, not songs, so 'Various' will only ever be returned for shows
        if (showOrSong.isCompilation) return 'Various';

        var names = [];
        for (var id in showOrSong[composersOrLyricists]) {
            names.push( showOrSong[composersOrLyricists][id].firstName + ' ' + showOrSong[composersOrLyricists][id].lastName );
        }
		
        return names.join(', ');
    }

    //TODO
    //Figure out why age ranges aren't being saved in order in the first place
	function sortAgeRanges(song) {
        var sorted = [];
        if (Array.isArray(song.ageRanges)) { //this should always be true, but just in case...
            var ageRangesAndSortNums = [];
            song.ageRanges.forEach(function(ageRange) {
                ageRangesAndSortNums.push({
                    sortNum: ageRangeOptions.indexOf(ageRange),
                    val: ageRange
                })
            });

            ageRangesAndSortNums = ageRangesAndSortNums.sort(function(a, b) {
                a = a.sortNum;
                b = b.sortNum;
                if( a == b) return 0;
                if( a > b) return 1;
                return -1;
            });

            song.ageRanges = [];
            ageRangesAndSortNums.forEach(function(obj) {
                song.ageRanges.push(obj.val);
            })
        }
	}
};